import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { getRepositoryQueryKey, useRepositoryQuery } from '@mews-commander/data-access';
import { useLanguageCode } from '@mews-commander/core';

export const useAssistantRecentSearchPromptQuery = () => {
    const languageCode = useLanguageCode();
    return useRepositoryQuery(
        'assistantUserPrompts',
        'getRecents',
        {
            languageCode,
        },
        {
            staleTime: 3000,
        }
    );
};

export const useInvalidateAssistantRecentSearchPromptQuery = () => {
    const queryClient = useQueryClient();
    const languageCode = useLanguageCode();

    return useCallback(() => {
        void queryClient.invalidateQueries({
            queryKey: getRepositoryQueryKey('assistantUserPrompts', 'getRecents', {
                languageCode,
            }),
        });
    }, [languageCode, queryClient]);
};
